import styled from "@emotion/styled";
import { FormHelperText } from "@mui/material";

export const FormErrorMessage = styled(FormHelperText)`
  color: ${(p) => p.theme.colors.error};
  margin-top: 3px;
  font-size: ${(p) => p.theme.text.fontSizes.xs};
  text-transform: uppercase;
  letter-spacing: 2px;
`;
